module.exports = __webpack_public_path__ + "static/media/surveyVector.18651da5.jpg";